module.exports = __webpack_public_path__ + "static/media/bg-hope.27077be1.jpg";